import { FC, memo } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { handleFetchResponse } from 'api/errors'
import { MODAL_IDS, ModalItem, ModalSimple, Seo, useModal } from 'components'
import { useOnMount } from 'hooks'
import {
  prepareContactUpdateData,
  useCreateContactMutation,
  useGetContactListQuery,
  useLazyGetContactListQuery
} from 'modules/contact/api'
import { ContactCreateForm } from 'modules/contact/components'

import { contactDetailRoute, contactRoute } from '../../routes'
import { TContact } from '../../types'

const ContactCreate: FC = () => {
  const navigate = useNavigate()
  const { closeModal, openModal } = useModal()
  const { refetch } = useGetContactListQuery('')
  const [getSearchContact] = useLazyGetContactListQuery()
  const [createContact, { isLoading: isCreating }] = useCreateContactMutation()

  const onClose = () => {
    closeModal(MODAL_IDS.ContactCreatePage)
    navigate(contactRoute)
  }

  const handleCreateContact = (contact: TContact) =>
    createContact(prepareContactUpdateData(contact)).then(
      handleFetchResponse((response) => {
        onClose()
        // TODO перенести на теги
        refetch()
        // TODO перейти на теги
        getSearchContact('')
        navigate({ to: contactDetailRoute.to, params: { id: response.data.contact.id } })
      })
    )

  useOnMount(() => openModal(MODAL_IDS.ContactCreatePage))

  return (
    <>
      <Seo
        description="Форма добавления нового контакта в сервис QP5 Express. Для размещения нового контакта достаточно заполнить ФИО и номер телефона."
        title="Новый контакт – сборные перевозки QP5 Express"
      />
      <ModalItem id={MODAL_IDS.ContactCreatePage}>
        <ModalSimple id={MODAL_IDS.ContactCreatePage} onClose={onClose} size="nm" title="Добавление контакта">
          <ContactCreateForm createContact={handleCreateContact} isCreating={isCreating} onClose={onClose} />
        </ModalSimple>
      </ModalItem>
    </>
  )
}

export default memo(ContactCreate)
